"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.petitionNotificationSignaturesSelectedUsersIds = exports.petitionNotificationFullStatistics = exports.petitionNotificationShortStatistics = exports.petitionNotifyFilters = exports.petitionNotificationUsersList = exports.petitionNotificationSelectedUsersIds = exports.petitionNotificationSelectedUsers = exports.petitionStatistics = exports.petitionSignatures = exports.petitionMySignature = exports.petitionFilters = exports.petitionAppeals = exports.petitionHistory = exports.petitionQuery = exports.listPetitionTemplates = exports.petitionsListHistory = exports.petitionsListFilters = exports.petitionsList = void 0;
var petitionsList_1 = require("./petitionsList");
Object.defineProperty(exports, "petitionsList", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionsList_1).default;
  }
});
var petitionsListFilters_1 = require("./petitionsListFilters");
Object.defineProperty(exports, "petitionsListFilters", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionsListFilters_1).default;
  }
});
var petitionsListHistory_1 = require("./petitionsListHistory");
Object.defineProperty(exports, "petitionsListHistory", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionsListHistory_1).default;
  }
});
var listPetitionTemplates_1 = require("./listPetitionTemplates");
Object.defineProperty(exports, "listPetitionTemplates", {
  enumerable: true,
  get: function () {
    return __importDefault(listPetitionTemplates_1).default;
  }
});
var petitionQuery_1 = require("./petitionQuery");
Object.defineProperty(exports, "petitionQuery", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionQuery_1).default;
  }
});
var petitionHistory_1 = require("./petitionHistory");
Object.defineProperty(exports, "petitionHistory", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionHistory_1).default;
  }
});
var petitionAppeals_1 = require("./petitionAppeals");
Object.defineProperty(exports, "petitionAppeals", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionAppeals_1).default;
  }
});
var petitionFilters_1 = require("./petitionFilters");
Object.defineProperty(exports, "petitionFilters", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionFilters_1).default;
  }
});
var petitionMySignature_1 = require("./petitionMySignature");
Object.defineProperty(exports, "petitionMySignature", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionMySignature_1).default;
  }
});
var petitionSignatures_1 = require("./petitionSignatures");
Object.defineProperty(exports, "petitionSignatures", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionSignatures_1).default;
  }
});
var petitionStatistics_1 = require("./petitionStatistics");
Object.defineProperty(exports, "petitionStatistics", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionStatistics_1).default;
  }
});
var petitionNotificationSelectedUsers_1 = require("./petitionNotificationSelectedUsers");
Object.defineProperty(exports, "petitionNotificationSelectedUsers", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionNotificationSelectedUsers_1).default;
  }
});
var petitionNotificationSelectedUsersIds_1 = require("./petitionNotificationSelectedUsersIds");
Object.defineProperty(exports, "petitionNotificationSelectedUsersIds", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionNotificationSelectedUsersIds_1).default;
  }
});
var petitionNotificationUsersList_1 = require("./petitionNotificationUsersList");
Object.defineProperty(exports, "petitionNotificationUsersList", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionNotificationUsersList_1).default;
  }
});
var petitionNotificationFilter_1 = require("./petitionNotificationFilter");
Object.defineProperty(exports, "petitionNotifyFilters", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionNotificationFilter_1).default;
  }
});
var petitionNotificationShortStatistics_1 = require("./petitionNotificationShortStatistics");
Object.defineProperty(exports, "petitionNotificationShortStatistics", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionNotificationShortStatistics_1).default;
  }
});
var petitionNotificationFullStatistics_1 = require("./petitionNotificationFullStatistics");
Object.defineProperty(exports, "petitionNotificationFullStatistics", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionNotificationFullStatistics_1).default;
  }
});
var petitionNotificationSignaturesSelectedUsersIds_1 = require("./petitionNotificationSignaturesSelectedUsersIds");
Object.defineProperty(exports, "petitionNotificationSignaturesSelectedUsersIds", {
  enumerable: true,
  get: function () {
    return __importDefault(petitionNotificationSignaturesSelectedUsersIds_1).default;
  }
});